module.exports = __webpack_public_path__ + "static/media/road-glide-special-snake-venom.09ee17f8.png";